import { useVoucherConfigStore } from '@nsftx/seven-client-retail-vue-sgp'
import { defineStore, storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

export const useVoucherSSBTStore = defineStore('voucherSSBTStore', () => {
  const voucherConfigStore = useVoucherConfigStore()
  const { voucherConfig } = storeToRefs(voucherConfigStore)

  const isVoucherDetailsOpened = ref(false)
  const isVoucherPinOpened = ref(false)

  const isVoucherPinEnabled = computed(() => voucherConfig.value?.pinProtection)

  const showVoucherDetailsModal = () => {
    isVoucherDetailsOpened.value = true
  }

  const closeVoucherDetailsModal = () => {
    isVoucherDetailsOpened.value = false
  }

  const showVoucherPinModal = () => {
    isVoucherPinOpened.value = true
  }

  const closeVoucherPinModal = () => {
    isVoucherPinOpened.value = false
  }

  return {
    isVoucherDetailsOpened,
    isVoucherPinOpened,
    isVoucherPinEnabled,
    showVoucherDetailsModal,
    closeVoucherDetailsModal,
    showVoucherPinModal,
    closeVoucherPinModal
  }
})
